/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface EmployeesService {
  /** @summary Me */
  meEmployeesMeGet: {
    /** @summary Me */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<MeEmployeesMeGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: MeEmployeesMeGetSchema,
        options: {
          parameters: MeEmployeesMeGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<MeEmployeesMeGetData, MeEmployeesMeGetError>>
    ): Promise<RequestFnResponse<MeEmployeesMeGetData, MeEmployeesMeGetError>>;
    /** @summary Me */
    getQueryKey(
      parameters: DeepReadonly<MeEmployeesMeGetParameters> | void
    ): ServiceOperationQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Me
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.employeesService.meEmployeesMeGet.useQuery()
     * ```
     */
    useQuery<TData = MeEmployeesMeGetData>(
      parameters:
        | ServiceOperationQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>
        | (DeepReadonly<MeEmployeesMeGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          MeEmployeesMeGetData,
          MeEmployeesMeGetError,
          TData,
          ServiceOperationQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<MeEmployeesMeGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Me
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.employeesService.meEmployeesMeGet.useQuery()
     * ```
     */
    useQuery<TData = MeEmployeesMeGetData>(
      parameters:
        | ServiceOperationQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>
        | (DeepReadonly<MeEmployeesMeGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          MeEmployeesMeGetData,
          MeEmployeesMeGetError,
          TData,
          ServiceOperationQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<MeEmployeesMeGetError>>;
    /** @summary Me */
    getInfiniteQueryKey(
      parameters: DeepReadonly<MeEmployeesMeGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Me
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeesService.meEmployeesMeGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends MeEmployeesMeGetParameters,
      TQueryFnData = MeEmployeesMeGetData,
      TData = OperationInfiniteData<TQueryFnData, MeEmployeesMeGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>
        | (DeepReadonly<MeEmployeesMeGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          MeEmployeesMeGetError,
          TData,
          ServiceOperationInfiniteQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<MeEmployeesMeGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Me
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeesService.meEmployeesMeGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends MeEmployeesMeGetParameters,
      TQueryFnData = MeEmployeesMeGetData,
      TData = OperationInfiniteData<TQueryFnData, MeEmployeesMeGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>
        | (DeepReadonly<MeEmployeesMeGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          MeEmployeesMeGetError,
          TData,
          ServiceOperationInfiniteQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<MeEmployeesMeGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<MeEmployeesMeGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Me
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const meEmployeesMeGetTotal = qraft.employeesService.meEmployeesMeGet.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            MeEmployeesMeGetSchema,
            MeEmployeesMeGetData,
            TInfinite,
            MeEmployeesMeGetParameters,
            MeEmployeesMeGetError
          >
        | QueryFiltersByQueryKey<
            MeEmployeesMeGetSchema,
            MeEmployeesMeGetData,
            TInfinite,
            MeEmployeesMeGetParameters,
            MeEmployeesMeGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Me
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const meEmployeesMeGetResults = qraft.employeesService.meEmployeesMeGet.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * meEmployeesMeGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const meEmployeesMeGetCombinedResults = qraft.employeesService.meEmployeesMeGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * meEmployeesMeGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          MeEmployeesMeGetSchema,
          MeEmployeesMeGetParameters,
          MeEmployeesMeGetData,
          MeEmployeesMeGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<MeEmployeesMeGetData, MeEmployeesMeGetError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<MeEmployeesMeGetData, MeEmployeesMeGetError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Me
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.employeesService.meEmployeesMeGet.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = MeEmployeesMeGetData>(
      parameters:
        | ServiceOperationQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>
        | (DeepReadonly<MeEmployeesMeGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          MeEmployeesMeGetData,
          MeEmployeesMeGetError,
          TData,
          ServiceOperationQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<MeEmployeesMeGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Me
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeesService.meEmployeesMeGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends MeEmployeesMeGetParameters, TData = MeEmployeesMeGetData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>
        | (DeepReadonly<MeEmployeesMeGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          MeEmployeesMeGetData,
          MeEmployeesMeGetError,
          OperationInfiniteData<TData, MeEmployeesMeGetParameters>,
          ServiceOperationInfiniteQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<MeEmployeesMeGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, MeEmployeesMeGetParameters>,
      OperationError<MeEmployeesMeGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Me
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const meEmployeesMeGetData = qraft.employeesService.meEmployeesMeGet.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * meEmployeesMeGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const meEmployeesMeGetCombinedData = qraft.employeesService.meEmployeesMeGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * meEmployeesMeGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          MeEmployeesMeGetSchema,
          MeEmployeesMeGetParameters,
          MeEmployeesMeGetData,
          MeEmployeesMeGetError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<MeEmployeesMeGetData, MeEmployeesMeGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<MeEmployeesMeGetData, MeEmployeesMeGetError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Me */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        MeEmployeesMeGetSchema,
        MeEmployeesMeGetData,
        MeEmployeesMeGetParameters,
        MeEmployeesMeGetError
      > | void
    ): Promise<MeEmployeesMeGetData>;
    /** @summary Me */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        MeEmployeesMeGetSchema,
        MeEmployeesMeGetData,
        MeEmployeesMeGetParameters,
        MeEmployeesMeGetError
      > | void
    ): Promise<void>;
    /** @summary Me */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        MeEmployeesMeGetSchema,
        MeEmployeesMeGetData,
        MeEmployeesMeGetParameters,
        MeEmployeesMeGetError
      > | void
    ): Promise<MeEmployeesMeGetData>;
    /** @summary Me */
    fetchInfiniteQuery<TPageParam extends MeEmployeesMeGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        MeEmployeesMeGetSchema,
        MeEmployeesMeGetData,
        MeEmployeesMeGetParameters,
        DeepReadonly<TPageParam>,
        MeEmployeesMeGetError
      > | void
    ): Promise<OperationInfiniteData<MeEmployeesMeGetData, MeEmployeesMeGetParameters>>;
    /** @summary Me */
    prefetchInfiniteQuery<TPageParam extends MeEmployeesMeGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        MeEmployeesMeGetSchema,
        MeEmployeesMeGetData,
        MeEmployeesMeGetParameters,
        DeepReadonly<TPageParam>,
        MeEmployeesMeGetError
      > | void
    ): Promise<void>;
    /** @summary Me */
    ensureInfiniteQueryData<TPageParam extends MeEmployeesMeGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        MeEmployeesMeGetSchema,
        MeEmployeesMeGetData,
        MeEmployeesMeGetParameters,
        DeepReadonly<TPageParam>,
        MeEmployeesMeGetError
      > | void
    ): Promise<OperationInfiniteData<MeEmployeesMeGetData, MeEmployeesMeGetParameters>>;
    /** @summary Me */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>
        | (DeepReadonly<MeEmployeesMeGetParameters> | void)
    ): MeEmployeesMeGetData | undefined;
    /** @summary Me */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>
        | (DeepReadonly<MeEmployeesMeGetParameters> | void)
    ): OperationInfiniteData<MeEmployeesMeGetData, MeEmployeesMeGetParameters> | undefined;
    /** @summary Me */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            MeEmployeesMeGetSchema,
            MeEmployeesMeGetData,
            TInfinite,
            MeEmployeesMeGetParameters,
            MeEmployeesMeGetError
          >
        | QueryFiltersByQueryKey<
            MeEmployeesMeGetSchema,
            MeEmployeesMeGetData,
            TInfinite,
            MeEmployeesMeGetParameters,
            MeEmployeesMeGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>,
            data: NoInfer<OperationInfiniteData<MeEmployeesMeGetData, MeEmployeesMeGetParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>,
            data: MeEmployeesMeGetData | undefined,
          ]
        >;
    /** @summary Me */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>
        | (DeepReadonly<MeEmployeesMeGetParameters> | void)
    ): QueryState<MeEmployeesMeGetData, MeEmployeesMeGetError> | undefined;
    /** @summary Me */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<MeEmployeesMeGetParameters>
        | ServiceOperationInfiniteQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>
        | void
    ):
      | QueryState<OperationInfiniteData<MeEmployeesMeGetData, MeEmployeesMeGetParameters>, MeEmployeesMeGetError>
      | undefined;
    /** @summary Me */
    setQueryData(
      parameters:
        | (DeepReadonly<MeEmployeesMeGetParameters> | undefined)
        | ServiceOperationQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>,
      updater: Updater<
        NoInfer<MeEmployeesMeGetData> | undefined,
        NoInfer<DeepReadonly<MeEmployeesMeGetData>> | undefined
      >,
      options?: SetDataOptions
    ): MeEmployeesMeGetData | undefined;
    /** @summary Me */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<MeEmployeesMeGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<MeEmployeesMeGetSchema, MeEmployeesMeGetParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<MeEmployeesMeGetData, MeEmployeesMeGetParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<MeEmployeesMeGetData, MeEmployeesMeGetParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<MeEmployeesMeGetData, MeEmployeesMeGetParameters> | undefined;
    /** @summary Me */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            MeEmployeesMeGetSchema,
            MeEmployeesMeGetData,
            TInfinite,
            MeEmployeesMeGetParameters,
            MeEmployeesMeGetError
          >
        | QueryFiltersByQueryKey<
            MeEmployeesMeGetSchema,
            MeEmployeesMeGetData,
            TInfinite,
            MeEmployeesMeGetParameters,
            MeEmployeesMeGetError
          >,
      updater: Updater<NoInfer<MeEmployeesMeGetData> | undefined, NoInfer<MeEmployeesMeGetData> | undefined>,
      options?: SetDataOptions
    ): Array<MeEmployeesMeGetData | undefined>;
    /** @summary Me */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        MeEmployeesMeGetSchema,
        MeEmployeesMeGetData,
        TInfinite,
        MeEmployeesMeGetParameters,
        MeEmployeesMeGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Me */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            MeEmployeesMeGetSchema,
            MeEmployeesMeGetData,
            TInfinite,
            MeEmployeesMeGetParameters,
            MeEmployeesMeGetError
          >
        | QueryFiltersByQueryKey<
            MeEmployeesMeGetSchema,
            MeEmployeesMeGetData,
            TInfinite,
            MeEmployeesMeGetParameters,
            MeEmployeesMeGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Me */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            MeEmployeesMeGetSchema,
            MeEmployeesMeGetData,
            TInfinite,
            MeEmployeesMeGetParameters,
            MeEmployeesMeGetError
          >
        | QueryFiltersByQueryKey<
            MeEmployeesMeGetSchema,
            MeEmployeesMeGetData,
            TInfinite,
            MeEmployeesMeGetParameters,
            MeEmployeesMeGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Me */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            MeEmployeesMeGetSchema,
            MeEmployeesMeGetData,
            TInfinite,
            MeEmployeesMeGetParameters,
            MeEmployeesMeGetError
          >
        | QueryFiltersByQueryKey<
            MeEmployeesMeGetSchema,
            MeEmployeesMeGetData,
            TInfinite,
            MeEmployeesMeGetParameters,
            MeEmployeesMeGetError
          >
    ): void;
    /** @summary Me */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            MeEmployeesMeGetSchema,
            MeEmployeesMeGetData,
            TInfinite,
            MeEmployeesMeGetParameters,
            MeEmployeesMeGetError
          >
        | QueryFiltersByQueryKey<
            MeEmployeesMeGetSchema,
            MeEmployeesMeGetData,
            TInfinite,
            MeEmployeesMeGetParameters,
            MeEmployeesMeGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Me */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            MeEmployeesMeGetSchema,
            MeEmployeesMeGetData,
            TInfinite,
            MeEmployeesMeGetParameters,
            MeEmployeesMeGetError
          >
        | QueryFiltersByQueryKey<
            MeEmployeesMeGetSchema,
            MeEmployeesMeGetData,
            TInfinite,
            MeEmployeesMeGetParameters,
            MeEmployeesMeGetError
          >
    ): number;
    schema: MeEmployeesMeGetSchema;
    types: {
      parameters: MeEmployeesMeGetParameters;
      data: MeEmployeesMeGetData;
      error: MeEmployeesMeGetError;
    };
  };
  /** @summary Get All */
  getAllEmployeesGet: {
    /** @summary Get All */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<GetAllEmployeesGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: GetAllEmployeesGetSchema,
        options: {
          parameters: GetAllEmployeesGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetAllEmployeesGetData, GetAllEmployeesGetError>>
    ): Promise<RequestFnResponse<GetAllEmployeesGetData, GetAllEmployeesGetError>>;
    /** @summary Get All */
    getQueryKey(
      parameters: DeepReadonly<GetAllEmployeesGetParameters> | void
    ): ServiceOperationQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.employeesService.getAllEmployeesGet.useQuery()
     * ```
     */
    useQuery<TData = GetAllEmployeesGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>
        | (DeepReadonly<GetAllEmployeesGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          GetAllEmployeesGetData,
          GetAllEmployeesGetError,
          TData,
          ServiceOperationQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetAllEmployeesGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.employeesService.getAllEmployeesGet.useQuery()
     * ```
     */
    useQuery<TData = GetAllEmployeesGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>
        | (DeepReadonly<GetAllEmployeesGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          GetAllEmployeesGetData,
          GetAllEmployeesGetError,
          TData,
          ServiceOperationQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetAllEmployeesGetError>>;
    /** @summary Get All */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetAllEmployeesGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeesService.getAllEmployeesGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllEmployeesGetParameters,
      TQueryFnData = GetAllEmployeesGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllEmployeesGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>
        | (DeepReadonly<GetAllEmployeesGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllEmployeesGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetAllEmployeesGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeesService.getAllEmployeesGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllEmployeesGetParameters,
      TQueryFnData = GetAllEmployeesGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllEmployeesGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>
        | (DeepReadonly<GetAllEmployeesGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllEmployeesGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetAllEmployeesGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetAllEmployeesGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getAllEmployeesGetTotal = qraft.employeesService.getAllEmployeesGet.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllEmployeesGetSchema,
            GetAllEmployeesGetData,
            TInfinite,
            GetAllEmployeesGetParameters,
            GetAllEmployeesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllEmployeesGetSchema,
            GetAllEmployeesGetData,
            TInfinite,
            GetAllEmployeesGetParameters,
            GetAllEmployeesGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getAllEmployeesGetResults = qraft.employeesService.getAllEmployeesGet.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllEmployeesGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getAllEmployeesGetCombinedResults = qraft.employeesService.getAllEmployeesGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllEmployeesGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetAllEmployeesGetSchema,
          GetAllEmployeesGetParameters,
          GetAllEmployeesGetData,
          GetAllEmployeesGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetAllEmployeesGetData, GetAllEmployeesGetError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<GetAllEmployeesGetData, GetAllEmployeesGetError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.employeesService.getAllEmployeesGet.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = GetAllEmployeesGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>
        | (DeepReadonly<GetAllEmployeesGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          GetAllEmployeesGetData,
          GetAllEmployeesGetError,
          TData,
          ServiceOperationQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetAllEmployeesGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeesService.getAllEmployeesGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends GetAllEmployeesGetParameters, TData = GetAllEmployeesGetData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>
        | (DeepReadonly<GetAllEmployeesGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetAllEmployeesGetData,
          GetAllEmployeesGetError,
          OperationInfiniteData<TData, GetAllEmployeesGetParameters>,
          ServiceOperationInfiniteQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetAllEmployeesGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetAllEmployeesGetParameters>,
      OperationError<GetAllEmployeesGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getAllEmployeesGetData = qraft.employeesService.getAllEmployeesGet.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllEmployeesGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getAllEmployeesGetCombinedData = qraft.employeesService.getAllEmployeesGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllEmployeesGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetAllEmployeesGetSchema,
          GetAllEmployeesGetParameters,
          GetAllEmployeesGetData,
          GetAllEmployeesGetError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<GetAllEmployeesGetData, GetAllEmployeesGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<GetAllEmployeesGetData, GetAllEmployeesGetError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get All */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllEmployeesGetSchema,
        GetAllEmployeesGetData,
        GetAllEmployeesGetParameters,
        GetAllEmployeesGetError
      > | void
    ): Promise<GetAllEmployeesGetData>;
    /** @summary Get All */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllEmployeesGetSchema,
        GetAllEmployeesGetData,
        GetAllEmployeesGetParameters,
        GetAllEmployeesGetError
      > | void
    ): Promise<void>;
    /** @summary Get All */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetAllEmployeesGetSchema,
        GetAllEmployeesGetData,
        GetAllEmployeesGetParameters,
        GetAllEmployeesGetError
      > | void
    ): Promise<GetAllEmployeesGetData>;
    /** @summary Get All */
    fetchInfiniteQuery<TPageParam extends GetAllEmployeesGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllEmployeesGetSchema,
        GetAllEmployeesGetData,
        GetAllEmployeesGetParameters,
        DeepReadonly<TPageParam>,
        GetAllEmployeesGetError
      > | void
    ): Promise<OperationInfiniteData<GetAllEmployeesGetData, GetAllEmployeesGetParameters>>;
    /** @summary Get All */
    prefetchInfiniteQuery<TPageParam extends GetAllEmployeesGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllEmployeesGetSchema,
        GetAllEmployeesGetData,
        GetAllEmployeesGetParameters,
        DeepReadonly<TPageParam>,
        GetAllEmployeesGetError
      > | void
    ): Promise<void>;
    /** @summary Get All */
    ensureInfiniteQueryData<TPageParam extends GetAllEmployeesGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetAllEmployeesGetSchema,
        GetAllEmployeesGetData,
        GetAllEmployeesGetParameters,
        DeepReadonly<TPageParam>,
        GetAllEmployeesGetError
      > | void
    ): Promise<OperationInfiniteData<GetAllEmployeesGetData, GetAllEmployeesGetParameters>>;
    /** @summary Get All */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>
        | (DeepReadonly<GetAllEmployeesGetParameters> | void)
    ): GetAllEmployeesGetData | undefined;
    /** @summary Get All */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>
        | (DeepReadonly<GetAllEmployeesGetParameters> | void)
    ): OperationInfiniteData<GetAllEmployeesGetData, GetAllEmployeesGetParameters> | undefined;
    /** @summary Get All */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllEmployeesGetSchema,
            GetAllEmployeesGetData,
            TInfinite,
            GetAllEmployeesGetParameters,
            GetAllEmployeesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllEmployeesGetSchema,
            GetAllEmployeesGetData,
            TInfinite,
            GetAllEmployeesGetParameters,
            GetAllEmployeesGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>,
            data: NoInfer<OperationInfiniteData<GetAllEmployeesGetData, GetAllEmployeesGetParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>,
            data: GetAllEmployeesGetData | undefined,
          ]
        >;
    /** @summary Get All */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>
        | (DeepReadonly<GetAllEmployeesGetParameters> | void)
    ): QueryState<GetAllEmployeesGetData, GetAllEmployeesGetError> | undefined;
    /** @summary Get All */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetAllEmployeesGetParameters>
        | ServiceOperationInfiniteQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>
        | void
    ):
      | QueryState<OperationInfiniteData<GetAllEmployeesGetData, GetAllEmployeesGetParameters>, GetAllEmployeesGetError>
      | undefined;
    /** @summary Get All */
    setQueryData(
      parameters:
        | (DeepReadonly<GetAllEmployeesGetParameters> | undefined)
        | ServiceOperationQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>,
      updater: Updater<
        NoInfer<GetAllEmployeesGetData> | undefined,
        NoInfer<DeepReadonly<GetAllEmployeesGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetAllEmployeesGetData | undefined;
    /** @summary Get All */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<GetAllEmployeesGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<GetAllEmployeesGetSchema, GetAllEmployeesGetParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<GetAllEmployeesGetData, GetAllEmployeesGetParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<GetAllEmployeesGetData, GetAllEmployeesGetParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetAllEmployeesGetData, GetAllEmployeesGetParameters> | undefined;
    /** @summary Get All */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetAllEmployeesGetSchema,
            GetAllEmployeesGetData,
            TInfinite,
            GetAllEmployeesGetParameters,
            GetAllEmployeesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllEmployeesGetSchema,
            GetAllEmployeesGetData,
            TInfinite,
            GetAllEmployeesGetParameters,
            GetAllEmployeesGetError
          >,
      updater: Updater<NoInfer<GetAllEmployeesGetData> | undefined, NoInfer<GetAllEmployeesGetData> | undefined>,
      options?: SetDataOptions
    ): Array<GetAllEmployeesGetData | undefined>;
    /** @summary Get All */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetAllEmployeesGetSchema,
        GetAllEmployeesGetData,
        TInfinite,
        GetAllEmployeesGetParameters,
        GetAllEmployeesGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get All */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllEmployeesGetSchema,
            GetAllEmployeesGetData,
            TInfinite,
            GetAllEmployeesGetParameters,
            GetAllEmployeesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllEmployeesGetSchema,
            GetAllEmployeesGetData,
            TInfinite,
            GetAllEmployeesGetParameters,
            GetAllEmployeesGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get All */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllEmployeesGetSchema,
            GetAllEmployeesGetData,
            TInfinite,
            GetAllEmployeesGetParameters,
            GetAllEmployeesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllEmployeesGetSchema,
            GetAllEmployeesGetData,
            TInfinite,
            GetAllEmployeesGetParameters,
            GetAllEmployeesGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get All */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllEmployeesGetSchema,
            GetAllEmployeesGetData,
            TInfinite,
            GetAllEmployeesGetParameters,
            GetAllEmployeesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllEmployeesGetSchema,
            GetAllEmployeesGetData,
            TInfinite,
            GetAllEmployeesGetParameters,
            GetAllEmployeesGetError
          >
    ): void;
    /** @summary Get All */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllEmployeesGetSchema,
            GetAllEmployeesGetData,
            TInfinite,
            GetAllEmployeesGetParameters,
            GetAllEmployeesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllEmployeesGetSchema,
            GetAllEmployeesGetData,
            TInfinite,
            GetAllEmployeesGetParameters,
            GetAllEmployeesGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get All */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllEmployeesGetSchema,
            GetAllEmployeesGetData,
            TInfinite,
            GetAllEmployeesGetParameters,
            GetAllEmployeesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllEmployeesGetSchema,
            GetAllEmployeesGetData,
            TInfinite,
            GetAllEmployeesGetParameters,
            GetAllEmployeesGetError
          >
    ): number;
    schema: GetAllEmployeesGetSchema;
    types: {
      parameters: GetAllEmployeesGetParameters;
      data: GetAllEmployeesGetData;
      error: GetAllEmployeesGetError;
    };
  };
  /** @summary Create */
  createEmployeesPost: {
    /** @summary Create */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CreateEmployeesPostBody,
        CreateEmployeesPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CreateEmployeesPostSchema,
        options: ServiceOperationMutationFnOptions<
          CreateEmployeesPostBody,
          CreateEmployeesPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<CreateEmployeesPostData, CreateEmployeesPostError>>
    ): Promise<RequestFnResponse<CreateEmployeesPostData, CreateEmployeesPostError>>;
    /** @summary Create */
    getMutationKey(
      parameters: DeepReadonly<CreateEmployeesPostParameters> | void
    ): ServiceOperationMutationKey<CreateEmployeesPostSchema, CreateEmployeesPostParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.createEmployeesPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.createEmployeesPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateEmployeesPostBody, TContext = unknown>(
      parameters: DeepReadonly<CreateEmployeesPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateEmployeesPostSchema,
        CreateEmployeesPostData,
        CreateEmployeesPostParameters,
        TVariables,
        OperationError<CreateEmployeesPostError>,
        TContext
      >
    ): UseMutationResult<CreateEmployeesPostData, OperationError<CreateEmployeesPostError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.createEmployeesPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.createEmployeesPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<CreateEmployeesPostBody, CreateEmployeesPostParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateEmployeesPostSchema,
        CreateEmployeesPostData,
        CreateEmployeesPostParameters,
        TVariables,
        OperationError<CreateEmployeesPostError>,
        TContext
      >
    ): UseMutationResult<CreateEmployeesPostData, OperationError<CreateEmployeesPostError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createEmployeesPostTotal = qraft.employeesService.createEmployeesPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createEmployeesPostTotal = qraft.employeesService.createEmployeesPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateEmployeesPostBody,
            CreateEmployeesPostData,
            CreateEmployeesPostParameters,
            OperationError<CreateEmployeesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateEmployeesPostSchema,
            CreateEmployeesPostBody,
            CreateEmployeesPostData,
            CreateEmployeesPostParameters,
            OperationError<CreateEmployeesPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createEmployeesPostPendingMutationVariables = qraft.employeesService.createEmployeesPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createEmployeesPostMutationData = qraft.employeesService.createEmployeesPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateEmployeesPostData,
        OperationError<CreateEmployeesPostError>,
        MutationVariables<CreateEmployeesPostBody, CreateEmployeesPostParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateEmployeesPostBody,
            CreateEmployeesPostData,
            CreateEmployeesPostParameters,
            OperationError<CreateEmployeesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateEmployeesPostSchema,
            CreateEmployeesPostBody,
            CreateEmployeesPostData,
            CreateEmployeesPostParameters,
            OperationError<CreateEmployeesPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateEmployeesPostData,
          OperationError<CreateEmployeesPostError>,
          MutationVariables<CreateEmployeesPostBody, CreateEmployeesPostParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Create */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateEmployeesPostBody,
            CreateEmployeesPostData,
            CreateEmployeesPostParameters,
            OperationError<CreateEmployeesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateEmployeesPostSchema,
            CreateEmployeesPostBody,
            CreateEmployeesPostData,
            CreateEmployeesPostParameters,
            OperationError<CreateEmployeesPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.employeesService.createEmployeesPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.employeesService.createEmployeesPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateEmployeesPostBody,
              CreateEmployeesPostData,
              CreateEmployeesPostParameters,
              OperationError<CreateEmployeesPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateEmployeesPostSchema,
              CreateEmployeesPostBody,
              CreateEmployeesPostData,
              CreateEmployeesPostParameters,
              OperationError<CreateEmployeesPostError>,
              TContext
            >
      ):
        | Mutation<
            CreateEmployeesPostData,
            CreateEmployeesPostError,
            MutationVariables<CreateEmployeesPostBody, CreateEmployeesPostParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateEmployeesPostBody,
              CreateEmployeesPostData,
              CreateEmployeesPostParameters,
              OperationError<CreateEmployeesPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateEmployeesPostSchema,
              CreateEmployeesPostBody,
              CreateEmployeesPostData,
              CreateEmployeesPostParameters,
              OperationError<CreateEmployeesPostError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateEmployeesPostData,
          CreateEmployeesPostError,
          MutationVariables<CreateEmployeesPostBody, CreateEmployeesPostParameters>,
          TContext
        >
      >;
    };
    schema: CreateEmployeesPostSchema;
    types: {
      parameters: CreateEmployeesPostParameters;
      data: CreateEmployeesPostData;
      error: CreateEmployeesPostError;
      body: CreateEmployeesPostBody;
    };
  };
  /** @summary Batch Update Employees */
  batchUpdateEmployees: {
    /** @summary Batch Update Employees */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        BatchUpdateEmployeesBody,
        BatchUpdateEmployeesParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: BatchUpdateEmployeesSchema,
        options: ServiceOperationMutationFnOptions<
          BatchUpdateEmployeesBody,
          BatchUpdateEmployeesParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<BatchUpdateEmployeesData, BatchUpdateEmployeesError>>
    ): Promise<RequestFnResponse<BatchUpdateEmployeesData, BatchUpdateEmployeesError>>;
    /** @summary Batch Update Employees */
    getMutationKey(
      parameters: DeepReadonly<BatchUpdateEmployeesParameters> | void
    ): ServiceOperationMutationKey<BatchUpdateEmployeesSchema, BatchUpdateEmployeesParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Batch Update Employees
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.batchUpdateEmployees.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.batchUpdateEmployees.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends BatchUpdateEmployeesBody, TContext = unknown>(
      parameters: DeepReadonly<BatchUpdateEmployeesParameters>,
      options?: ServiceOperationUseMutationOptions<
        BatchUpdateEmployeesSchema,
        BatchUpdateEmployeesData,
        BatchUpdateEmployeesParameters,
        TVariables,
        OperationError<BatchUpdateEmployeesError>,
        TContext
      >
    ): UseMutationResult<BatchUpdateEmployeesData, OperationError<BatchUpdateEmployeesError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Batch Update Employees
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.batchUpdateEmployees.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.batchUpdateEmployees.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<BatchUpdateEmployeesBody, BatchUpdateEmployeesParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        BatchUpdateEmployeesSchema,
        BatchUpdateEmployeesData,
        BatchUpdateEmployeesParameters,
        TVariables,
        OperationError<BatchUpdateEmployeesError>,
        TContext
      >
    ): UseMutationResult<BatchUpdateEmployeesData, OperationError<BatchUpdateEmployeesError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Batch Update Employees
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const batchUpdateEmployeesTotal = qraft.employeesService.batchUpdateEmployees.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const batchUpdateEmployeesTotal = qraft.employeesService.batchUpdateEmployees.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            BatchUpdateEmployeesBody,
            BatchUpdateEmployeesData,
            BatchUpdateEmployeesParameters,
            OperationError<BatchUpdateEmployeesError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            BatchUpdateEmployeesSchema,
            BatchUpdateEmployeesBody,
            BatchUpdateEmployeesData,
            BatchUpdateEmployeesParameters,
            OperationError<BatchUpdateEmployeesError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Batch Update Employees
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const batchUpdateEmployeesPendingMutationVariables = qraft.employeesService.batchUpdateEmployees.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const batchUpdateEmployeesMutationData = qraft.employeesService.batchUpdateEmployees.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        BatchUpdateEmployeesData,
        OperationError<BatchUpdateEmployeesError>,
        MutationVariables<BatchUpdateEmployeesBody, BatchUpdateEmployeesParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            BatchUpdateEmployeesBody,
            BatchUpdateEmployeesData,
            BatchUpdateEmployeesParameters,
            OperationError<BatchUpdateEmployeesError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            BatchUpdateEmployeesSchema,
            BatchUpdateEmployeesBody,
            BatchUpdateEmployeesData,
            BatchUpdateEmployeesParameters,
            OperationError<BatchUpdateEmployeesError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          BatchUpdateEmployeesData,
          OperationError<BatchUpdateEmployeesError>,
          MutationVariables<BatchUpdateEmployeesBody, BatchUpdateEmployeesParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Batch Update Employees */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            BatchUpdateEmployeesBody,
            BatchUpdateEmployeesData,
            BatchUpdateEmployeesParameters,
            OperationError<BatchUpdateEmployeesError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            BatchUpdateEmployeesSchema,
            BatchUpdateEmployeesBody,
            BatchUpdateEmployeesData,
            BatchUpdateEmployeesParameters,
            OperationError<BatchUpdateEmployeesError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Batch Update Employees
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.employeesService.batchUpdateEmployees.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.employeesService.batchUpdateEmployees.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              BatchUpdateEmployeesBody,
              BatchUpdateEmployeesData,
              BatchUpdateEmployeesParameters,
              OperationError<BatchUpdateEmployeesError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              BatchUpdateEmployeesSchema,
              BatchUpdateEmployeesBody,
              BatchUpdateEmployeesData,
              BatchUpdateEmployeesParameters,
              OperationError<BatchUpdateEmployeesError>,
              TContext
            >
      ):
        | Mutation<
            BatchUpdateEmployeesData,
            BatchUpdateEmployeesError,
            MutationVariables<BatchUpdateEmployeesBody, BatchUpdateEmployeesParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              BatchUpdateEmployeesBody,
              BatchUpdateEmployeesData,
              BatchUpdateEmployeesParameters,
              OperationError<BatchUpdateEmployeesError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              BatchUpdateEmployeesSchema,
              BatchUpdateEmployeesBody,
              BatchUpdateEmployeesData,
              BatchUpdateEmployeesParameters,
              OperationError<BatchUpdateEmployeesError>,
              TContext
            >
      ): Array<
        Mutation<
          BatchUpdateEmployeesData,
          BatchUpdateEmployeesError,
          MutationVariables<BatchUpdateEmployeesBody, BatchUpdateEmployeesParameters>,
          TContext
        >
      >;
    };
    schema: BatchUpdateEmployeesSchema;
    types: {
      parameters: BatchUpdateEmployeesParameters;
      data: BatchUpdateEmployeesData;
      error: BatchUpdateEmployeesError;
      body: BatchUpdateEmployeesBody;
    };
  };
  /** @summary Update */
  updateEmployeesEmployeeIdPut: {
    /** @summary Update */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        UpdateEmployeesEmployeeIdPutBody,
        UpdateEmployeesEmployeeIdPutParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: UpdateEmployeesEmployeeIdPutSchema,
        options: ServiceOperationMutationFnOptions<
          UpdateEmployeesEmployeeIdPutBody,
          UpdateEmployeesEmployeeIdPutParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<UpdateEmployeesEmployeeIdPutData, UpdateEmployeesEmployeeIdPutError>>
    ): Promise<RequestFnResponse<UpdateEmployeesEmployeeIdPutData, UpdateEmployeesEmployeeIdPutError>>;
    /** @summary Update */
    getMutationKey(
      parameters: DeepReadonly<UpdateEmployeesEmployeeIdPutParameters> | void
    ): ServiceOperationMutationKey<UpdateEmployeesEmployeeIdPutSchema, UpdateEmployeesEmployeeIdPutParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.updateEmployeesEmployeeIdPut.useMutation({
     *     path: {
     *         employee_id: employeeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.updateEmployeesEmployeeIdPut.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         employee_id: employeeId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends UpdateEmployeesEmployeeIdPutBody, TContext = unknown>(
      parameters: DeepReadonly<UpdateEmployeesEmployeeIdPutParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateEmployeesEmployeeIdPutSchema,
        UpdateEmployeesEmployeeIdPutData,
        UpdateEmployeesEmployeeIdPutParameters,
        TVariables,
        OperationError<UpdateEmployeesEmployeeIdPutError>,
        TContext
      >
    ): UseMutationResult<
      UpdateEmployeesEmployeeIdPutData,
      OperationError<UpdateEmployeesEmployeeIdPutError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.updateEmployeesEmployeeIdPut.useMutation({
     *     path: {
     *         employee_id: employeeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.updateEmployeesEmployeeIdPut.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         employee_id: employeeId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<UpdateEmployeesEmployeeIdPutBody, UpdateEmployeesEmployeeIdPutParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateEmployeesEmployeeIdPutSchema,
        UpdateEmployeesEmployeeIdPutData,
        UpdateEmployeesEmployeeIdPutParameters,
        TVariables,
        OperationError<UpdateEmployeesEmployeeIdPutError>,
        TContext
      >
    ): UseMutationResult<
      UpdateEmployeesEmployeeIdPutData,
      OperationError<UpdateEmployeesEmployeeIdPutError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateEmployeesEmployeeIdPutTotal = qraft.employeesService.updateEmployeesEmployeeIdPut.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateEmployeesEmployeeIdPutTotal = qraft.employeesService.updateEmployeesEmployeeIdPut.useIsMutating({
     *     parameters: {
     *         path: {
     *             employee_id: employeeId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateEmployeesEmployeeIdPutBody,
            UpdateEmployeesEmployeeIdPutData,
            UpdateEmployeesEmployeeIdPutParameters,
            OperationError<UpdateEmployeesEmployeeIdPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateEmployeesEmployeeIdPutSchema,
            UpdateEmployeesEmployeeIdPutBody,
            UpdateEmployeesEmployeeIdPutData,
            UpdateEmployeesEmployeeIdPutParameters,
            OperationError<UpdateEmployeesEmployeeIdPutError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateEmployeesEmployeeIdPutPendingMutationVariables = qraft.employeesService.updateEmployeesEmployeeIdPut.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateEmployeesEmployeeIdPutMutationData = qraft.employeesService.updateEmployeesEmployeeIdPut.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 employee_id: employeeId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateEmployeesEmployeeIdPutData,
        OperationError<UpdateEmployeesEmployeeIdPutError>,
        MutationVariables<UpdateEmployeesEmployeeIdPutBody, UpdateEmployeesEmployeeIdPutParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateEmployeesEmployeeIdPutBody,
            UpdateEmployeesEmployeeIdPutData,
            UpdateEmployeesEmployeeIdPutParameters,
            OperationError<UpdateEmployeesEmployeeIdPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateEmployeesEmployeeIdPutSchema,
            UpdateEmployeesEmployeeIdPutBody,
            UpdateEmployeesEmployeeIdPutData,
            UpdateEmployeesEmployeeIdPutParameters,
            OperationError<UpdateEmployeesEmployeeIdPutError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateEmployeesEmployeeIdPutData,
          OperationError<UpdateEmployeesEmployeeIdPutError>,
          MutationVariables<UpdateEmployeesEmployeeIdPutBody, UpdateEmployeesEmployeeIdPutParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Update */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateEmployeesEmployeeIdPutBody,
            UpdateEmployeesEmployeeIdPutData,
            UpdateEmployeesEmployeeIdPutParameters,
            OperationError<UpdateEmployeesEmployeeIdPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateEmployeesEmployeeIdPutSchema,
            UpdateEmployeesEmployeeIdPutBody,
            UpdateEmployeesEmployeeIdPutData,
            UpdateEmployeesEmployeeIdPutParameters,
            OperationError<UpdateEmployeesEmployeeIdPutError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.employeesService.updateEmployeesEmployeeIdPut.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             employee_id: employeeId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.employeesService.updateEmployeesEmployeeIdPut.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateEmployeesEmployeeIdPutBody,
              UpdateEmployeesEmployeeIdPutData,
              UpdateEmployeesEmployeeIdPutParameters,
              OperationError<UpdateEmployeesEmployeeIdPutError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateEmployeesEmployeeIdPutSchema,
              UpdateEmployeesEmployeeIdPutBody,
              UpdateEmployeesEmployeeIdPutData,
              UpdateEmployeesEmployeeIdPutParameters,
              OperationError<UpdateEmployeesEmployeeIdPutError>,
              TContext
            >
      ):
        | Mutation<
            UpdateEmployeesEmployeeIdPutData,
            UpdateEmployeesEmployeeIdPutError,
            MutationVariables<UpdateEmployeesEmployeeIdPutBody, UpdateEmployeesEmployeeIdPutParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateEmployeesEmployeeIdPutBody,
              UpdateEmployeesEmployeeIdPutData,
              UpdateEmployeesEmployeeIdPutParameters,
              OperationError<UpdateEmployeesEmployeeIdPutError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateEmployeesEmployeeIdPutSchema,
              UpdateEmployeesEmployeeIdPutBody,
              UpdateEmployeesEmployeeIdPutData,
              UpdateEmployeesEmployeeIdPutParameters,
              OperationError<UpdateEmployeesEmployeeIdPutError>,
              TContext
            >
      ): Array<
        Mutation<
          UpdateEmployeesEmployeeIdPutData,
          UpdateEmployeesEmployeeIdPutError,
          MutationVariables<UpdateEmployeesEmployeeIdPutBody, UpdateEmployeesEmployeeIdPutParameters>,
          TContext
        >
      >;
    };
    schema: UpdateEmployeesEmployeeIdPutSchema;
    types: {
      parameters: UpdateEmployeesEmployeeIdPutParameters;
      data: UpdateEmployeesEmployeeIdPutData;
      error: UpdateEmployeesEmployeeIdPutError;
      body: UpdateEmployeesEmployeeIdPutBody;
    };
  };
  /** @summary Admin List Employees */
  adminListEmployees: {
    /** @summary Admin List Employees */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<AdminListEmployeesParameters, TMeta, TSignal> | void),
      client?: (
        schema: AdminListEmployeesSchema,
        options: {
          parameters: AdminListEmployeesParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<AdminListEmployeesData, AdminListEmployeesError>>
    ): Promise<RequestFnResponse<AdminListEmployeesData, AdminListEmployeesError>>;
    /** @summary Admin List Employees */
    getQueryKey(
      parameters: DeepReadonly<AdminListEmployeesParameters> | void
    ): ServiceOperationQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Admin List Employees
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.employeesService.adminListEmployees.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.employeesService.adminListEmployees.useQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useQuery<TData = AdminListEmployeesData>(
      parameters:
        | ServiceOperationQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>
        | (DeepReadonly<AdminListEmployeesParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          AdminListEmployeesData,
          AdminListEmployeesError,
          TData,
          ServiceOperationQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<AdminListEmployeesError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Admin List Employees
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.employeesService.adminListEmployees.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.employeesService.adminListEmployees.useQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useQuery<TData = AdminListEmployeesData>(
      parameters:
        | ServiceOperationQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>
        | (DeepReadonly<AdminListEmployeesParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          AdminListEmployeesData,
          AdminListEmployeesError,
          TData,
          ServiceOperationQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<AdminListEmployeesError>>;
    /** @summary Admin List Employees */
    getInfiniteQueryKey(
      parameters: DeepReadonly<AdminListEmployeesParameters> | void
    ): ServiceOperationInfiniteQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Admin List Employees
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeesService.adminListEmployees.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends AdminListEmployeesParameters,
      TQueryFnData = AdminListEmployeesData,
      TData = OperationInfiniteData<TQueryFnData, AdminListEmployeesParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>
        | (DeepReadonly<AdminListEmployeesParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          AdminListEmployeesError,
          TData,
          ServiceOperationInfiniteQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<AdminListEmployeesError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Admin List Employees
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeesService.adminListEmployees.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends AdminListEmployeesParameters,
      TQueryFnData = AdminListEmployeesData,
      TData = OperationInfiniteData<TQueryFnData, AdminListEmployeesParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>
        | (DeepReadonly<AdminListEmployeesParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          AdminListEmployeesError,
          TData,
          ServiceOperationInfiniteQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<AdminListEmployeesData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<AdminListEmployeesError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Admin List Employees
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const adminListEmployeesTotal = qraft.employeesService.adminListEmployees.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const adminListEmployeesByParametersTotal = qraft.employeesService.adminListEmployees.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             office_id: officeId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            AdminListEmployeesSchema,
            AdminListEmployeesData,
            TInfinite,
            AdminListEmployeesParameters,
            AdminListEmployeesError
          >
        | QueryFiltersByQueryKey<
            AdminListEmployeesSchema,
            AdminListEmployeesData,
            TInfinite,
            AdminListEmployeesParameters,
            AdminListEmployeesError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Admin List Employees
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const adminListEmployeesResults = qraft.employeesService.adminListEmployees.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * adminListEmployeesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const adminListEmployeesCombinedResults = qraft.employeesService.adminListEmployees.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * adminListEmployeesCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          AdminListEmployeesSchema,
          AdminListEmployeesParameters,
          AdminListEmployeesData,
          AdminListEmployeesError
        >
      >,
      TCombinedResult = Array<UseQueryResult<AdminListEmployeesData, AdminListEmployeesError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<AdminListEmployeesData, AdminListEmployeesError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Admin List Employees
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.employeesService.adminListEmployees.useSuspenseQuery()
     * ```
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.employeesService.adminListEmployees.useSuspenseQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = AdminListEmployeesData>(
      parameters:
        | ServiceOperationQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>
        | (DeepReadonly<AdminListEmployeesParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          AdminListEmployeesData,
          AdminListEmployeesError,
          TData,
          ServiceOperationQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<AdminListEmployeesError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Admin List Employees
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.employeesService.adminListEmployees.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends AdminListEmployeesParameters, TData = AdminListEmployeesData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>
        | (DeepReadonly<AdminListEmployeesParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          AdminListEmployeesData,
          AdminListEmployeesError,
          OperationInfiniteData<TData, AdminListEmployeesParameters>,
          ServiceOperationInfiniteQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<AdminListEmployeesData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, AdminListEmployeesParameters>,
      OperationError<AdminListEmployeesError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Admin List Employees
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const adminListEmployeesData = qraft.employeesService.adminListEmployees.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * adminListEmployeesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const adminListEmployeesCombinedData = qraft.employeesService.adminListEmployees.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * adminListEmployeesCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          AdminListEmployeesSchema,
          AdminListEmployeesParameters,
          AdminListEmployeesData,
          AdminListEmployeesError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<AdminListEmployeesData, AdminListEmployeesError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<AdminListEmployeesData, AdminListEmployeesError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Admin List Employees */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        AdminListEmployeesSchema,
        AdminListEmployeesData,
        AdminListEmployeesParameters,
        AdminListEmployeesError
      > | void
    ): Promise<AdminListEmployeesData>;
    /** @summary Admin List Employees */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        AdminListEmployeesSchema,
        AdminListEmployeesData,
        AdminListEmployeesParameters,
        AdminListEmployeesError
      > | void
    ): Promise<void>;
    /** @summary Admin List Employees */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        AdminListEmployeesSchema,
        AdminListEmployeesData,
        AdminListEmployeesParameters,
        AdminListEmployeesError
      > | void
    ): Promise<AdminListEmployeesData>;
    /** @summary Admin List Employees */
    fetchInfiniteQuery<TPageParam extends AdminListEmployeesParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        AdminListEmployeesSchema,
        AdminListEmployeesData,
        AdminListEmployeesParameters,
        DeepReadonly<TPageParam>,
        AdminListEmployeesError
      > | void
    ): Promise<OperationInfiniteData<AdminListEmployeesData, AdminListEmployeesParameters>>;
    /** @summary Admin List Employees */
    prefetchInfiniteQuery<TPageParam extends AdminListEmployeesParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        AdminListEmployeesSchema,
        AdminListEmployeesData,
        AdminListEmployeesParameters,
        DeepReadonly<TPageParam>,
        AdminListEmployeesError
      > | void
    ): Promise<void>;
    /** @summary Admin List Employees */
    ensureInfiniteQueryData<TPageParam extends AdminListEmployeesParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        AdminListEmployeesSchema,
        AdminListEmployeesData,
        AdminListEmployeesParameters,
        DeepReadonly<TPageParam>,
        AdminListEmployeesError
      > | void
    ): Promise<OperationInfiniteData<AdminListEmployeesData, AdminListEmployeesParameters>>;
    /** @summary Admin List Employees */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>
        | (DeepReadonly<AdminListEmployeesParameters> | void)
    ): AdminListEmployeesData | undefined;
    /** @summary Admin List Employees */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>
        | (DeepReadonly<AdminListEmployeesParameters> | void)
    ): OperationInfiniteData<AdminListEmployeesData, AdminListEmployeesParameters> | undefined;
    /** @summary Admin List Employees */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            AdminListEmployeesSchema,
            AdminListEmployeesData,
            TInfinite,
            AdminListEmployeesParameters,
            AdminListEmployeesError
          >
        | QueryFiltersByQueryKey<
            AdminListEmployeesSchema,
            AdminListEmployeesData,
            TInfinite,
            AdminListEmployeesParameters,
            AdminListEmployeesError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>,
            data: NoInfer<OperationInfiniteData<AdminListEmployeesData, AdminListEmployeesParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>,
            data: AdminListEmployeesData | undefined,
          ]
        >;
    /** @summary Admin List Employees */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>
        | (DeepReadonly<AdminListEmployeesParameters> | void)
    ): QueryState<AdminListEmployeesData, AdminListEmployeesError> | undefined;
    /** @summary Admin List Employees */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<AdminListEmployeesParameters>
        | ServiceOperationInfiniteQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>
        | void
    ):
      | QueryState<OperationInfiniteData<AdminListEmployeesData, AdminListEmployeesParameters>, AdminListEmployeesError>
      | undefined;
    /** @summary Admin List Employees */
    setQueryData(
      parameters:
        | (DeepReadonly<AdminListEmployeesParameters> | undefined)
        | ServiceOperationQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>,
      updater: Updater<
        NoInfer<AdminListEmployeesData> | undefined,
        NoInfer<DeepReadonly<AdminListEmployeesData>> | undefined
      >,
      options?: SetDataOptions
    ): AdminListEmployeesData | undefined;
    /** @summary Admin List Employees */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<AdminListEmployeesParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<AdminListEmployeesSchema, AdminListEmployeesParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<AdminListEmployeesData, AdminListEmployeesParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<AdminListEmployeesData, AdminListEmployeesParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<AdminListEmployeesData, AdminListEmployeesParameters> | undefined;
    /** @summary Admin List Employees */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            AdminListEmployeesSchema,
            AdminListEmployeesData,
            TInfinite,
            AdminListEmployeesParameters,
            AdminListEmployeesError
          >
        | QueryFiltersByQueryKey<
            AdminListEmployeesSchema,
            AdminListEmployeesData,
            TInfinite,
            AdminListEmployeesParameters,
            AdminListEmployeesError
          >,
      updater: Updater<NoInfer<AdminListEmployeesData> | undefined, NoInfer<AdminListEmployeesData> | undefined>,
      options?: SetDataOptions
    ): Array<AdminListEmployeesData | undefined>;
    /** @summary Admin List Employees */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        AdminListEmployeesSchema,
        AdminListEmployeesData,
        TInfinite,
        AdminListEmployeesParameters,
        AdminListEmployeesError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Admin List Employees */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            AdminListEmployeesSchema,
            AdminListEmployeesData,
            TInfinite,
            AdminListEmployeesParameters,
            AdminListEmployeesError
          >
        | QueryFiltersByQueryKey<
            AdminListEmployeesSchema,
            AdminListEmployeesData,
            TInfinite,
            AdminListEmployeesParameters,
            AdminListEmployeesError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Admin List Employees */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            AdminListEmployeesSchema,
            AdminListEmployeesData,
            TInfinite,
            AdminListEmployeesParameters,
            AdminListEmployeesError
          >
        | QueryFiltersByQueryKey<
            AdminListEmployeesSchema,
            AdminListEmployeesData,
            TInfinite,
            AdminListEmployeesParameters,
            AdminListEmployeesError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Admin List Employees */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            AdminListEmployeesSchema,
            AdminListEmployeesData,
            TInfinite,
            AdminListEmployeesParameters,
            AdminListEmployeesError
          >
        | QueryFiltersByQueryKey<
            AdminListEmployeesSchema,
            AdminListEmployeesData,
            TInfinite,
            AdminListEmployeesParameters,
            AdminListEmployeesError
          >
    ): void;
    /** @summary Admin List Employees */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            AdminListEmployeesSchema,
            AdminListEmployeesData,
            TInfinite,
            AdminListEmployeesParameters,
            AdminListEmployeesError
          >
        | QueryFiltersByQueryKey<
            AdminListEmployeesSchema,
            AdminListEmployeesData,
            TInfinite,
            AdminListEmployeesParameters,
            AdminListEmployeesError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Admin List Employees */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            AdminListEmployeesSchema,
            AdminListEmployeesData,
            TInfinite,
            AdminListEmployeesParameters,
            AdminListEmployeesError
          >
        | QueryFiltersByQueryKey<
            AdminListEmployeesSchema,
            AdminListEmployeesData,
            TInfinite,
            AdminListEmployeesParameters,
            AdminListEmployeesError
          >
    ): number;
    schema: AdminListEmployeesSchema;
    types: {
      parameters: AdminListEmployeesParameters;
      data: AdminListEmployeesData;
      error: AdminListEmployeesError;
    };
  };
  /** @summary Switch To Employee */
  switchToEmployee: {
    /** @summary Switch To Employee */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<SwitchToEmployeeBody, SwitchToEmployeeParameters, TMeta, TSignal>,
      client?: (
        schema: SwitchToEmployeeSchema,
        options: ServiceOperationMutationFnOptions<SwitchToEmployeeBody, SwitchToEmployeeParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<SwitchToEmployeeData, SwitchToEmployeeError>>
    ): Promise<RequestFnResponse<SwitchToEmployeeData, SwitchToEmployeeError>>;
    /** @summary Switch To Employee */
    getMutationKey(
      parameters: DeepReadonly<SwitchToEmployeeParameters> | void
    ): ServiceOperationMutationKey<SwitchToEmployeeSchema, SwitchToEmployeeParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Switch To Employee
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.switchToEmployee.useMutation({
     *     query: {
     *         employee_id: employeeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.switchToEmployee.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     query: {
     *         employee_id: employeeId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends SwitchToEmployeeBody, TContext = unknown>(
      parameters: DeepReadonly<SwitchToEmployeeParameters>,
      options?: ServiceOperationUseMutationOptions<
        SwitchToEmployeeSchema,
        SwitchToEmployeeData,
        SwitchToEmployeeParameters,
        TVariables,
        OperationError<SwitchToEmployeeError>,
        TContext
      >
    ): UseMutationResult<SwitchToEmployeeData, OperationError<SwitchToEmployeeError>, TVariables | void, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Switch To Employee
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.switchToEmployee.useMutation({
     *     query: {
     *         employee_id: employeeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.switchToEmployee.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     query: {
     *         employee_id: employeeId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<SwitchToEmployeeBody, SwitchToEmployeeParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        SwitchToEmployeeSchema,
        SwitchToEmployeeData,
        SwitchToEmployeeParameters,
        TVariables,
        OperationError<SwitchToEmployeeError>,
        TContext
      >
    ): UseMutationResult<SwitchToEmployeeData, OperationError<SwitchToEmployeeError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Switch To Employee
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const switchToEmployeeTotal = qraft.employeesService.switchToEmployee.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const switchToEmployeeTotal = qraft.employeesService.switchToEmployee.useIsMutating({
     *     parameters: {
     *         query: {
     *             employee_id: employeeId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            SwitchToEmployeeBody,
            SwitchToEmployeeData,
            SwitchToEmployeeParameters,
            OperationError<SwitchToEmployeeError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SwitchToEmployeeSchema,
            SwitchToEmployeeBody,
            SwitchToEmployeeData,
            SwitchToEmployeeParameters,
            OperationError<SwitchToEmployeeError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Switch To Employee
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const switchToEmployeePendingMutationVariables = qraft.employeesService.switchToEmployee.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const switchToEmployeeMutationData = qraft.employeesService.switchToEmployee.useMutationState({
     *     filters: {
     *         parameters: {
     *             query: {
     *                 employee_id: employeeId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        SwitchToEmployeeData,
        OperationError<SwitchToEmployeeError>,
        MutationVariables<SwitchToEmployeeBody, SwitchToEmployeeParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            SwitchToEmployeeBody,
            SwitchToEmployeeData,
            SwitchToEmployeeParameters,
            OperationError<SwitchToEmployeeError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SwitchToEmployeeSchema,
            SwitchToEmployeeBody,
            SwitchToEmployeeData,
            SwitchToEmployeeParameters,
            OperationError<SwitchToEmployeeError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          SwitchToEmployeeData,
          OperationError<SwitchToEmployeeError>,
          MutationVariables<SwitchToEmployeeBody, SwitchToEmployeeParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Switch To Employee */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            SwitchToEmployeeBody,
            SwitchToEmployeeData,
            SwitchToEmployeeParameters,
            OperationError<SwitchToEmployeeError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SwitchToEmployeeSchema,
            SwitchToEmployeeBody,
            SwitchToEmployeeData,
            SwitchToEmployeeParameters,
            OperationError<SwitchToEmployeeError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Switch To Employee
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.employeesService.switchToEmployee.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         query: {
     *             employee_id: employeeId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.employeesService.switchToEmployee.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              SwitchToEmployeeBody,
              SwitchToEmployeeData,
              SwitchToEmployeeParameters,
              OperationError<SwitchToEmployeeError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SwitchToEmployeeSchema,
              SwitchToEmployeeBody,
              SwitchToEmployeeData,
              SwitchToEmployeeParameters,
              OperationError<SwitchToEmployeeError>,
              TContext
            >
      ):
        | Mutation<
            SwitchToEmployeeData,
            SwitchToEmployeeError,
            MutationVariables<SwitchToEmployeeBody, SwitchToEmployeeParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              SwitchToEmployeeBody,
              SwitchToEmployeeData,
              SwitchToEmployeeParameters,
              OperationError<SwitchToEmployeeError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SwitchToEmployeeSchema,
              SwitchToEmployeeBody,
              SwitchToEmployeeData,
              SwitchToEmployeeParameters,
              OperationError<SwitchToEmployeeError>,
              TContext
            >
      ): Array<
        Mutation<
          SwitchToEmployeeData,
          SwitchToEmployeeError,
          MutationVariables<SwitchToEmployeeBody, SwitchToEmployeeParameters>,
          TContext
        >
      >;
    };
    schema: SwitchToEmployeeSchema;
    types: {
      parameters: SwitchToEmployeeParameters;
      data: SwitchToEmployeeData;
      error: SwitchToEmployeeError;
      body: SwitchToEmployeeBody;
    };
  };
  /** @summary Switch To Office */
  switchToOffice: {
    /** @summary Switch To Office */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<SwitchToOfficeBody, SwitchToOfficeParameters, TMeta, TSignal>,
      client?: (
        schema: SwitchToOfficeSchema,
        options: ServiceOperationMutationFnOptions<SwitchToOfficeBody, SwitchToOfficeParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<SwitchToOfficeData, SwitchToOfficeError>>
    ): Promise<RequestFnResponse<SwitchToOfficeData, SwitchToOfficeError>>;
    /** @summary Switch To Office */
    getMutationKey(
      parameters: DeepReadonly<SwitchToOfficeParameters> | void
    ): ServiceOperationMutationKey<SwitchToOfficeSchema, SwitchToOfficeParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Switch To Office
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.switchToOffice.useMutation({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.switchToOffice.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     query: {
     *         office_id: officeId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends SwitchToOfficeBody, TContext = unknown>(
      parameters: DeepReadonly<SwitchToOfficeParameters>,
      options?: ServiceOperationUseMutationOptions<
        SwitchToOfficeSchema,
        SwitchToOfficeData,
        SwitchToOfficeParameters,
        TVariables,
        OperationError<SwitchToOfficeError>,
        TContext
      >
    ): UseMutationResult<SwitchToOfficeData, OperationError<SwitchToOfficeError>, TVariables | void, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Switch To Office
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.switchToOffice.useMutation({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.switchToOffice.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     query: {
     *         office_id: officeId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends MutationVariables<SwitchToOfficeBody, SwitchToOfficeParameters>, TContext = unknown>(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        SwitchToOfficeSchema,
        SwitchToOfficeData,
        SwitchToOfficeParameters,
        TVariables,
        OperationError<SwitchToOfficeError>,
        TContext
      >
    ): UseMutationResult<SwitchToOfficeData, OperationError<SwitchToOfficeError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Switch To Office
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const switchToOfficeTotal = qraft.employeesService.switchToOffice.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const switchToOfficeTotal = qraft.employeesService.switchToOffice.useIsMutating({
     *     parameters: {
     *         query: {
     *             office_id: officeId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            SwitchToOfficeBody,
            SwitchToOfficeData,
            SwitchToOfficeParameters,
            OperationError<SwitchToOfficeError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SwitchToOfficeSchema,
            SwitchToOfficeBody,
            SwitchToOfficeData,
            SwitchToOfficeParameters,
            OperationError<SwitchToOfficeError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Switch To Office
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const switchToOfficePendingMutationVariables = qraft.employeesService.switchToOffice.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const switchToOfficeMutationData = qraft.employeesService.switchToOffice.useMutationState({
     *     filters: {
     *         parameters: {
     *             query: {
     *                 office_id: officeId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        SwitchToOfficeData,
        OperationError<SwitchToOfficeError>,
        MutationVariables<SwitchToOfficeBody, SwitchToOfficeParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            SwitchToOfficeBody,
            SwitchToOfficeData,
            SwitchToOfficeParameters,
            OperationError<SwitchToOfficeError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SwitchToOfficeSchema,
            SwitchToOfficeBody,
            SwitchToOfficeData,
            SwitchToOfficeParameters,
            OperationError<SwitchToOfficeError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          SwitchToOfficeData,
          OperationError<SwitchToOfficeError>,
          MutationVariables<SwitchToOfficeBody, SwitchToOfficeParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Switch To Office */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            SwitchToOfficeBody,
            SwitchToOfficeData,
            SwitchToOfficeParameters,
            OperationError<SwitchToOfficeError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SwitchToOfficeSchema,
            SwitchToOfficeBody,
            SwitchToOfficeData,
            SwitchToOfficeParameters,
            OperationError<SwitchToOfficeError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Switch To Office
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.employeesService.switchToOffice.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         query: {
     *             office_id: officeId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.employeesService.switchToOffice.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              SwitchToOfficeBody,
              SwitchToOfficeData,
              SwitchToOfficeParameters,
              OperationError<SwitchToOfficeError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SwitchToOfficeSchema,
              SwitchToOfficeBody,
              SwitchToOfficeData,
              SwitchToOfficeParameters,
              OperationError<SwitchToOfficeError>,
              TContext
            >
      ):
        | Mutation<
            SwitchToOfficeData,
            SwitchToOfficeError,
            MutationVariables<SwitchToOfficeBody, SwitchToOfficeParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              SwitchToOfficeBody,
              SwitchToOfficeData,
              SwitchToOfficeParameters,
              OperationError<SwitchToOfficeError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SwitchToOfficeSchema,
              SwitchToOfficeBody,
              SwitchToOfficeData,
              SwitchToOfficeParameters,
              OperationError<SwitchToOfficeError>,
              TContext
            >
      ): Array<
        Mutation<
          SwitchToOfficeData,
          SwitchToOfficeError,
          MutationVariables<SwitchToOfficeBody, SwitchToOfficeParameters>,
          TContext
        >
      >;
    };
    schema: SwitchToOfficeSchema;
    types: {
      parameters: SwitchToOfficeParameters;
      data: SwitchToOfficeData;
      error: SwitchToOfficeError;
      body: SwitchToOfficeBody;
    };
  };
  /** @summary Reset Employee Cookie */
  resetEmployeeCookie: {
    /** @summary Reset Employee Cookie */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        ResetEmployeeCookieBody,
        ResetEmployeeCookieParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: ResetEmployeeCookieSchema,
        options: ServiceOperationMutationFnOptions<
          ResetEmployeeCookieBody,
          ResetEmployeeCookieParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<ResetEmployeeCookieData, ResetEmployeeCookieError>>
    ): Promise<RequestFnResponse<ResetEmployeeCookieData, ResetEmployeeCookieError>>;
    /** @summary Reset Employee Cookie */
    getMutationKey(
      parameters: DeepReadonly<ResetEmployeeCookieParameters> | void
    ): ServiceOperationMutationKey<ResetEmployeeCookieSchema, ResetEmployeeCookieParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Reset Employee Cookie
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.resetEmployeeCookie.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.resetEmployeeCookie.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends ResetEmployeeCookieBody, TContext = unknown>(
      parameters: DeepReadonly<ResetEmployeeCookieParameters>,
      options?: ServiceOperationUseMutationOptions<
        ResetEmployeeCookieSchema,
        ResetEmployeeCookieData,
        ResetEmployeeCookieParameters,
        TVariables,
        OperationError<ResetEmployeeCookieError>,
        TContext
      >
    ): UseMutationResult<
      ResetEmployeeCookieData,
      OperationError<ResetEmployeeCookieError>,
      TVariables | void,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Reset Employee Cookie
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.resetEmployeeCookie.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.employeesService.resetEmployeeCookie.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<ResetEmployeeCookieBody, ResetEmployeeCookieParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        ResetEmployeeCookieSchema,
        ResetEmployeeCookieData,
        ResetEmployeeCookieParameters,
        TVariables,
        OperationError<ResetEmployeeCookieError>,
        TContext
      >
    ): UseMutationResult<ResetEmployeeCookieData, OperationError<ResetEmployeeCookieError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Reset Employee Cookie
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const resetEmployeeCookieTotal = qraft.employeesService.resetEmployeeCookie.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const resetEmployeeCookieTotal = qraft.employeesService.resetEmployeeCookie.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            ResetEmployeeCookieBody,
            ResetEmployeeCookieData,
            ResetEmployeeCookieParameters,
            OperationError<ResetEmployeeCookieError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            ResetEmployeeCookieSchema,
            ResetEmployeeCookieBody,
            ResetEmployeeCookieData,
            ResetEmployeeCookieParameters,
            OperationError<ResetEmployeeCookieError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Reset Employee Cookie
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const resetEmployeeCookiePendingMutationVariables = qraft.employeesService.resetEmployeeCookie.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const resetEmployeeCookieMutationData = qraft.employeesService.resetEmployeeCookie.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        ResetEmployeeCookieData,
        OperationError<ResetEmployeeCookieError>,
        MutationVariables<ResetEmployeeCookieBody, ResetEmployeeCookieParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            ResetEmployeeCookieBody,
            ResetEmployeeCookieData,
            ResetEmployeeCookieParameters,
            OperationError<ResetEmployeeCookieError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            ResetEmployeeCookieSchema,
            ResetEmployeeCookieBody,
            ResetEmployeeCookieData,
            ResetEmployeeCookieParameters,
            OperationError<ResetEmployeeCookieError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          ResetEmployeeCookieData,
          OperationError<ResetEmployeeCookieError>,
          MutationVariables<ResetEmployeeCookieBody, ResetEmployeeCookieParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Reset Employee Cookie */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            ResetEmployeeCookieBody,
            ResetEmployeeCookieData,
            ResetEmployeeCookieParameters,
            OperationError<ResetEmployeeCookieError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            ResetEmployeeCookieSchema,
            ResetEmployeeCookieBody,
            ResetEmployeeCookieData,
            ResetEmployeeCookieParameters,
            OperationError<ResetEmployeeCookieError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Reset Employee Cookie
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.employeesService.resetEmployeeCookie.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.employeesService.resetEmployeeCookie.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              ResetEmployeeCookieBody,
              ResetEmployeeCookieData,
              ResetEmployeeCookieParameters,
              OperationError<ResetEmployeeCookieError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              ResetEmployeeCookieSchema,
              ResetEmployeeCookieBody,
              ResetEmployeeCookieData,
              ResetEmployeeCookieParameters,
              OperationError<ResetEmployeeCookieError>,
              TContext
            >
      ):
        | Mutation<
            ResetEmployeeCookieData,
            ResetEmployeeCookieError,
            MutationVariables<ResetEmployeeCookieBody, ResetEmployeeCookieParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              ResetEmployeeCookieBody,
              ResetEmployeeCookieData,
              ResetEmployeeCookieParameters,
              OperationError<ResetEmployeeCookieError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              ResetEmployeeCookieSchema,
              ResetEmployeeCookieBody,
              ResetEmployeeCookieData,
              ResetEmployeeCookieParameters,
              OperationError<ResetEmployeeCookieError>,
              TContext
            >
      ): Array<
        Mutation<
          ResetEmployeeCookieData,
          ResetEmployeeCookieError,
          MutationVariables<ResetEmployeeCookieBody, ResetEmployeeCookieParameters>,
          TContext
        >
      >;
    };
    schema: ResetEmployeeCookieSchema;
    types: {
      parameters: ResetEmployeeCookieParameters;
      data: ResetEmployeeCookieData;
      error: ResetEmployeeCookieError;
      body: ResetEmployeeCookieBody;
    };
  };
}
/** @summary Me */
export const meEmployeesMeGet = {
  schema: {
    method: 'get',
    url: '/employees/me',
    security: ['HTTPBearer'],
  },
} as {
  schema: MeEmployeesMeGetSchema;
  [QraftServiceOperationsToken]: EmployeesService['meEmployeesMeGet'];
};
/** @summary Get All */
export const getAllEmployeesGet = {
  schema: {
    method: 'get',
    url: '/employees/',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetAllEmployeesGetSchema;
  [QraftServiceOperationsToken]: EmployeesService['getAllEmployeesGet'];
};
/** @summary Create */
export const createEmployeesPost = {
  schema: {
    method: 'post',
    url: '/employees/',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateEmployeesPostSchema;
  [QraftServiceOperationsToken]: EmployeesService['createEmployeesPost'];
};
/** @summary Batch Update Employees */
export const batchUpdateEmployees = {
  schema: {
    method: 'post',
    url: '/employees/batch/update',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: BatchUpdateEmployeesSchema;
  [QraftServiceOperationsToken]: EmployeesService['batchUpdateEmployees'];
};
/** @summary Update */
export const updateEmployeesEmployeeIdPut = {
  schema: {
    method: 'put',
    url: '/employees/{employee_id}',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UpdateEmployeesEmployeeIdPutSchema;
  [QraftServiceOperationsToken]: EmployeesService['updateEmployeesEmployeeIdPut'];
};
/** @summary Admin List Employees */
export const adminListEmployees = {
  schema: {
    method: 'get',
    url: '/employees/admin/list',
    security: ['HTTPBearer'],
  },
} as {
  schema: AdminListEmployeesSchema;
  [QraftServiceOperationsToken]: EmployeesService['adminListEmployees'];
};
/** @summary Switch To Employee */
export const switchToEmployee = {
  schema: {
    method: 'post',
    url: '/employees/admin/switch_to_employee',
    security: ['HTTPBearer'],
  },
} as {
  schema: SwitchToEmployeeSchema;
  [QraftServiceOperationsToken]: EmployeesService['switchToEmployee'];
};
/** @summary Switch To Office */
export const switchToOffice = {
  schema: {
    method: 'post',
    url: '/employees/admin/switch_to_office',
    security: ['HTTPBearer'],
  },
} as {
  schema: SwitchToOfficeSchema;
  [QraftServiceOperationsToken]: EmployeesService['switchToOffice'];
};
/** @summary Reset Employee Cookie */
export const resetEmployeeCookie = {
  schema: {
    method: 'post',
    url: '/employees/admin/reset_employee_cookie',
  },
} as {
  schema: ResetEmployeeCookieSchema;
  [QraftServiceOperationsToken]: EmployeesService['resetEmployeeCookie'];
};
export const employeesService = {
  meEmployeesMeGet,
  getAllEmployeesGet,
  createEmployeesPost,
  batchUpdateEmployees,
  updateEmployeesEmployeeIdPut,
  adminListEmployees,
  switchToEmployee,
  switchToOffice,
  resetEmployeeCookie,
} as const;
type MeEmployeesMeGetSchema = {
  method: 'get';
  url: '/employees/me';
  security: ['HTTPBearer'];
};
type MeEmployeesMeGetParameters = undefined;
type MeEmployeesMeGetData = paths['/employees/me']['get']['responses']['200']['content']['application/json'];
type MeEmployeesMeGetError = unknown;
type GetAllEmployeesGetSchema = {
  method: 'get';
  url: '/employees/';
  security: ['HTTPBearer'];
};
type GetAllEmployeesGetParameters = undefined;
type GetAllEmployeesGetData = paths['/employees/']['get']['responses']['200']['content']['application/json'];
type GetAllEmployeesGetError = unknown;
type CreateEmployeesPostSchema = {
  method: 'post';
  url: '/employees/';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CreateEmployeesPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateEmployeesPostData = paths['/employees/']['post']['responses']['200']['content']['application/json'];
type CreateEmployeesPostError = paths['/employees/']['post']['responses']['422']['content']['application/json'];
type CreateEmployeesPostBody = paths['/employees/']['post']['requestBody']['content']['application/json'];
type BatchUpdateEmployeesSchema = {
  method: 'post';
  url: '/employees/batch/update';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type BatchUpdateEmployeesParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type BatchUpdateEmployeesData =
  paths['/employees/batch/update']['post']['responses']['200']['content']['application/json'];
type BatchUpdateEmployeesError =
  paths['/employees/batch/update']['post']['responses']['422']['content']['application/json'];
type BatchUpdateEmployeesBody = paths['/employees/batch/update']['post']['requestBody']['content']['application/json'];
type UpdateEmployeesEmployeeIdPutSchema = {
  method: 'put';
  url: '/employees/{employee_id}';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type UpdateEmployeesEmployeeIdPutParameters = paths['/employees/{employee_id}']['put']['parameters'];
type UpdateEmployeesEmployeeIdPutData =
  paths['/employees/{employee_id}']['put']['responses']['200']['content']['application/json'];
type UpdateEmployeesEmployeeIdPutError =
  paths['/employees/{employee_id}']['put']['responses']['422']['content']['application/json'];
type UpdateEmployeesEmployeeIdPutBody =
  paths['/employees/{employee_id}']['put']['requestBody']['content']['application/json'];
type AdminListEmployeesSchema = {
  method: 'get';
  url: '/employees/admin/list';
  security: ['HTTPBearer'];
};
type AdminListEmployeesParameters = paths['/employees/admin/list']['get']['parameters'];
type AdminListEmployeesData = paths['/employees/admin/list']['get']['responses']['200']['content']['application/json'];
type AdminListEmployeesError = paths['/employees/admin/list']['get']['responses']['422']['content']['application/json'];
type SwitchToEmployeeSchema = {
  method: 'post';
  url: '/employees/admin/switch_to_employee';
  security: ['HTTPBearer'];
};
type SwitchToEmployeeParameters = paths['/employees/admin/switch_to_employee']['post']['parameters'];
type SwitchToEmployeeData =
  paths['/employees/admin/switch_to_employee']['post']['responses']['200']['content']['application/json'];
type SwitchToEmployeeError =
  paths['/employees/admin/switch_to_employee']['post']['responses']['422']['content']['application/json'];
type SwitchToEmployeeBody = undefined;
type SwitchToOfficeSchema = {
  method: 'post';
  url: '/employees/admin/switch_to_office';
  security: ['HTTPBearer'];
};
type SwitchToOfficeParameters = paths['/employees/admin/switch_to_office']['post']['parameters'];
type SwitchToOfficeData =
  paths['/employees/admin/switch_to_office']['post']['responses']['200']['content']['application/json'];
type SwitchToOfficeError =
  paths['/employees/admin/switch_to_office']['post']['responses']['422']['content']['application/json'];
type SwitchToOfficeBody = undefined;
type ResetEmployeeCookieSchema = {
  method: 'post';
  url: '/employees/admin/reset_employee_cookie';
};
type ResetEmployeeCookieParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type ResetEmployeeCookieData =
  paths['/employees/admin/reset_employee_cookie']['post']['responses']['200']['content']['application/json'];
type ResetEmployeeCookieError = unknown;
type ResetEmployeeCookieBody = undefined;
